import { render, staticRenderFns } from "./RecursiveField.vue?vue&type=template&id=ba3f63b8&"
import script from "./RecursiveField.vue?vue&type=script&lang=js&"
export * from "./RecursiveField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports